import React from "react";

// Material UI
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const LatestLeadsHeader = ({ order, orderBy, onRequestSort, classes }) => {
  const headCells = [
    { id: "leadID", numeric: true, label: "Lead ID" },
    { id: "customerName", numeric: false, label: "Customer Name" },
    { id: "campaignName", numeric: false, label: "Campaign" },
    { id: "email", numeric: false, label: "Email" },
    { id: "IP", numeric: false, label: "IP" },
    { id: "visitorHash", numeric: false, label: "Visitor Hash" },
    { id: "date", numeric: false, label: "Lead Date/Time" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({id, label}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
            size="medium"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default LatestLeadsHeader;
